<template>
    <div :class="['e__switch',{'e_is-checked':innerValue}]">
        <span class="e__switch-core" @click="toggle()" v-if="!$props.disabled"></span>
        <span class="e__switch-core" v-else></span>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch } from 'vue'

    const props = withDefaults(
      defineProps<{
        modelValue?: Boolean,
        disabled?: Boolean
      }>(),
      {
        modelValue: false,
        disabled: false
      }
    )

    const emits = defineEmits<{
      (e: 'update:modelValue', value: boolean): void,
      (e: 'change', value: boolean): void
    }>()

    const innerValue = ref(props.modelValue)

    // 侦听文本变化并传给外界
    watch(
      () => innerValue.value,
      () => {
          emits('update:modelValue', innerValue.value)
          // emits('change', innerValue.value)
      }
    )
    // 侦听默认值 外界第一次传进来一个 v-model 就赋值给 contentValue
    watch(
      () => props.modelValue,
      (n: any) => {
        innerValue.value = n
      }
    )

    const toggle = () => {
        innerValue.value = !innerValue.value
    }
</script>

<style>
    .e__switch {
        display: inline-flex;
        align-items: center;
        position: relative;
        font-size: 14px;
        line-height: 20px;
        height: 20px;
        vertical-align: middle;
    }

    .e__switch>input {
        position: absolute;
        width: 0;
        height: 0;
        opacity: 0;
        margin: 0;
    }

    .e__switch-core {
        margin: 0;
        position: relative;
        width: 40px;
        height: 20px;
        border: 1px solid #DCDFE6;
        outline: 0;
        border-radius: 10px;
        box-sizing: border-box;
        background: #DCDFE6;
        transition: border-color .3s, background-color .3s;
        vertical-align: middle;
        cursor: pointer;
    }

    .e__switch-core::after {
        content: "";
        position: absolute;
        top: 1px;
        left: 1px;
        border-radius: 100%;
        transition: all .3s;
        width: 16px;
        height: 16px;
        background-color: #FFF;
    }
    
    .e__switch.e_is-checked .e__switch-core {
        border-color: #409EFF;
        background-color: #409EFF;
    }
    
    .e__switch.e_is-checked .e__switch-core::after {
        left: 100%;
        margin-left: -17px;
    }
</style>
